module.exports = __webpack_public_path__ + "assets/img/cc97720b0d1f79a00bbbbab227ebfb7e.svg";